export const AVATAR_UPLOAD_ENDPOINT = 'https://cubemeet-avatar-upload.cubemeet.app';
export const SHOPPING_IMAGE_UPLOAD_ENDPOINT = 'https://cubemeet-shopping-upload.your-subdomain.workers.dev';
export const RECEIPT_UPLOAD_ENDPOINT = 'https://cubemeet-receipts-upload.cubemeet.app';
export const CDN_BASE_URL = 'https://cdn.cubemeet.app';
export const AUTH_API_ENDPOINT = 'https://cubemeet-auth.your-subdomain.workers.dev';
